document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.variants-items__selector input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', function (e) {
      const form = e.target.closest('form');
      const submitButton = form.querySelector('button[type="submit"]');
      const spinner = submitButton?.querySelector('.loading-overlay__spinner');
      const hiddenIdInput = form.querySelector('input[name="id"]');
      const variantId = e.target.value;

      if (!form || !variantId || !hiddenIdInput) return;

      hiddenIdInput.disabled = false;
      hiddenIdInput.value = variantId;
      spinner?.classList.remove('hidden');

      const formData = new FormData(form);
      formData.set('id', variantId);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          spinner?.classList.add('hidden');
          console.log('✅ Producto añadido al carrito:', data);
          // Dirije al carrito según idioma
          const lang = document.documentElement.lang || 'es';
          const langPrefix = ['es', 'en', 'fr', 'pt-PT'].includes(lang) ? (lang === 'es' ? '' : `/${lang.split('-')[0]}`) : '';
          window.location.href = `${langPrefix}/cart`;
        })
        .catch(error => {
          spinner?.classList.add('hidden');
          console.log('❌ Error en la petición de añadir al carrito:', error);
        });
    });
  });
});
